import { Component } from '@angular/core';
import { CustomInputComponent } from '../../../shared-components/custom-input/custom-input.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-inputs',
	templateUrl: './inputs.component.html',
	styleUrls: ['./inputs.component.scss'],
	standalone: false,
})
export class InputsComponent {
	basicValue: string = '';
	emailValue: string = '';
	requiredValue: string = '';
	passwordValue: string = '';
	numberValue: string = '';
	disabledValue: string = '';
	validationValid = false;
	requiredInputRules: any[] = [];

	constructor(private translateService: TranslateService) {
		this.requiredInputRules = [CustomInputComponent.createRules(this.translateService).required('This field is required')];
	}

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}

	onInputChange(type: string, value: string): void {
		if (type === 'basic') this.basicValue = value;
		else if (type === 'email') this.emailValue = value;
		else if (type === 'required') this.requiredValue = value;
		else if (type === 'password') this.passwordValue = value;
		else if (type === 'number') this.numberValue = value;
		else if (type === 'disabled') this.disabledValue = value;
	}
}
